import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Importação dos arquivos de tradução
import ptBRCommon from './locales/pt-BR/common.json';
import ptBRHeader from './locales/pt-BR/header.json';
import ptBRCampaigns from './locales/pt-BR/campaigns.json';
import ptBRFacades from './locales/pt-BR/facades.json';
import ptBRMarketingStudio from './locales/pt-BR/marketingStudio.json';
import ptBRAuth from './locales/pt-BR/auth.json';
import ptBRDashboard from './locales/pt-BR/dashboard.json';
import ptBRBilling from './locales/pt-BR/billing.json';
import ptBRAdmin from './locales/pt-BR/admin.json';
import ptBRTags from './locales/pt-BR/tags.json';
import ptBRUI from './locales/pt-BR/ui.json';
import ptBRImageUploadAnalysisAdvanced from './locales/pt-BR/image_upload_analysis_advanced.json';
import ptBRImageUploadAnalysisGuided from './locales/pt-BR/image_upload_analysis_guided.json';
import ptBRTaskComposition from './locales/pt-BR/task_composition.json';
import ptBRNewTasksGuidedPage from './locales/pt-BR/new_tasks_guided_page.json';
import ptBRPhotoPresets from './locales/pt-BR/photo_presets.json';
import ptBRPromptGeneration from './locales/pt-BR/prompt_generation.json';
import ptBRPromptPreview from './locales/pt-BR/prompt_preview.json';
import ptBRGeneratedLooksPage from './locales/pt-BR/generated_looks_page.json';
import ptBRImageEditing from './locales/pt-BR/image_editing.json';
import ptBRErrorBoundary from './locales/pt-BR/error_boundary.json';
import ptBRMoodboards from './locales/pt-BR/moodboards.json';
import ptBRStills from './locales/pt-BR/stills.json';
import ptBRAccessories from './locales/pt-BR/accessories.json';
import ptBRVeo from './locales/pt-BR/veo.json';
import ptBRModels from './locales/pt-BR/models.json';
import ptBRBrandbookV2 from './locales/pt-BR/brandbook_v2.json';
import ptBRConnectors from './locales/pt-BR/connectors.json';
import ptBRVto from './locales/pt-BR/vto.json';
import ptBROrders from './locales/pt-BR/orders.json';
import ptBRAssistant from './locales/pt-BR/assistant.json';

import enCommon from './locales/en/common.json';
import enHeader from './locales/en/header.json';
import enCampaigns from './locales/en/campaigns.json';
import enFacades from './locales/en/facades.json';
import enMarketingStudio from './locales/en/marketingStudio.json';
import enAuth from './locales/en/auth.json';
import enDashboard from './locales/en/dashboard.json';
import enBilling from './locales/en/billing.json';
import enAdmin from './locales/en/admin.json';
import enTags from './locales/en/tags.json';
import enUI from './locales/en/ui.json';
import enImageUploadAnalysisAdvanced from './locales/en/image_upload_analysis_advanced.json';
import enImageUploadAnalysisGuided from './locales/en/image_upload_analysis_guided.json';
import enTaskComposition from './locales/en/task_composition.json';
import enNewTasksGuidedPage from './locales/en/new_tasks_guided_page.json';
import enPhotoPresets from './locales/en/photo_presets.json';
import enPromptGeneration from './locales/en/prompt_generation.json';
import enPromptPreview from './locales/en/prompt_preview.json';
import enGeneratedLooksPage from './locales/en/generated_looks_page.json';
import enImageEditing from './locales/en/image_editing.json';
import enErrorBoundary from './locales/en/error_boundary.json';
import enMoodboards from './locales/en/moodboards.json';
import enStills from './locales/en/stills.json';
import enAccessories from './locales/en/accessories.json';
import enVeo from './locales/en/veo.json';
import enModels from './locales/en/models.json';
import enBrandbookV2 from './locales/en/brandbook_v2.json';
import enConnectors from './locales/en/connectors.json';
import enVto from './locales/en/vto.json';
import enOrders from './locales/en/orders.json';
import enAssistant from './locales/en/assistant.json';

// Recursos de tradução agrupados por idioma e namespace
const resources = {
    'pt-BR': {
        common: ptBRCommon,
        header: ptBRHeader,
        campaigns: ptBRCampaigns,
        facades: ptBRFacades,
        marketingStudio: ptBRMarketingStudio,
        auth: ptBRAuth,
        dashboard: ptBRDashboard,
        billing: ptBRBilling,
        admin: ptBRAdmin,
        tags: ptBRTags,
        ui: ptBRUI,
        image_upload_analysis_advanced: ptBRImageUploadAnalysisAdvanced,
        image_upload_analysis_guided: ptBRImageUploadAnalysisGuided,
        task_composition: ptBRTaskComposition,
        new_tasks_guided_page: ptBRNewTasksGuidedPage,
        photo_presets: ptBRPhotoPresets,
        prompt_generation: ptBRPromptGeneration,
        prompt_preview: ptBRPromptPreview,
        generated_looks_page: ptBRGeneratedLooksPage,
        image_editing: ptBRImageEditing,
        error_boundary: ptBRErrorBoundary,
        moodboards: ptBRMoodboards,
        stills: ptBRStills,
        accessories: ptBRAccessories,
        veo: ptBRVeo,
        models: ptBRModels,
        brandbook_v2: ptBRBrandbookV2,
        connectors: ptBRConnectors,
        vto: ptBRVto,
        orders: ptBROrders,
        assistant: ptBRAssistant
    },
    en: {
        common: enCommon,
        header: enHeader,
        campaigns: enCampaigns,
        facades: enFacades,
        marketingStudio: enMarketingStudio,
        auth: enAuth,
        dashboard: enDashboard,
        billing: enBilling,
        admin: enAdmin,
        tags: enTags,
        ui: enUI,
        image_upload_analysis_advanced: enImageUploadAnalysisAdvanced,
        image_upload_analysis_guided: enImageUploadAnalysisGuided,
        task_composition: enTaskComposition,
        new_tasks_guided_page: enNewTasksGuidedPage,
        photo_presets: enPhotoPresets,
        prompt_generation: enPromptGeneration,
        prompt_preview: enPromptPreview,
        generated_looks_page: enGeneratedLooksPage,
        image_editing: enImageEditing,
        error_boundary: enErrorBoundary,
        moodboards: enMoodboards,
        stills: enStills,
        accessories: enAccessories,
        veo: enVeo,
        models: enModels,
        brandbook_v2: enBrandbookV2,
        connectors: enConnectors,
        vto: enVto,
        orders: enOrders,
        assistant: enAssistant
    }
};

// Idioma persistido: o seletor de idioma do menu grava aqui; padrão pt-BR.
export const LANGUAGE_STORAGE_KEY = 'snapfy_language';
const storedLanguage = typeof window !== 'undefined' ? window.localStorage.getItem(LANGUAGE_STORAGE_KEY) : null;

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: storedLanguage === 'en' || storedLanguage === 'pt-BR' ? storedLanguage : 'pt-BR',
        fallbackLng: 'pt-BR',
        interpolation: {
            escapeValue: false, // não necessário para React
        },
        ns: ['common', 'header', 'campaigns', 'facades', 'marketingStudio', 'auth', 'dashboard', 'billing', 'admin', 'tags', 'ui', 'image_upload_analysis_advanced', 'image_upload_analysis_guided', 'task_composition', 'new_tasks_guided_page', 'photo_presets', 'prompt_generation', 'prompt_preview', 'generated_looks_page', 'image_editing', 'error_boundary', 'moodboards', 'stills', 'accessories', 'veo', 'models', 'brandbook_v2', 'connectors', 'vto', 'orders', 'assistant'], // namespaces disponíveis
        defaultNS: 'common',
    });

export default i18n;
